import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import * as rxsync from '@ivlasov/rxsync';
import * as _ from 'lodash';
import { LodashService } from './lodash.service';
import * as io from 'socket.io-client';
import { EfoEgiService } from './egi.service';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ElevationService } from './elevation.service';

@Injectable({
  providedIn: 'root',
})
export class EfoOmtService {
  //private url = 'http://socket1.carbrewer.com:3002';
  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;
  private elevationUrl = environment.nestElevationApiUrl;

  private activeAccounts$: BehaviorSubject<any> = new BehaviorSubject([]);
  public readonly activeAccounts: Observable<any> =
    this.activeAccounts$.asObservable();
  private selectedAccount$: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly selectedAccount: Observable<any> =
    this.selectedAccount$.asObservable();
  public account: any = {};
  private selectedCampaign$: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly selectedCampaign: Observable<any> =
    this.selectedCampaign$.asObservable();
  private accountCampaigns$: BehaviorSubject<any> = new BehaviorSubject([]);
  public readonly accountCampaigns: Observable<any> =
    this.accountCampaigns$.asObservable();
  public campaign: any = {};

  //public selectedAccount = {}

  constructor(
    private efoLd: LodashService,
    private efoEgi: EfoEgiService,
    private http: HttpClient,
    private elevationService: ElevationService,
  ) {
    this.getActiveAccounts().subscribe();
    this.selectedAccount$.subscribe((account) => {
      if (_.has(account, 'account_num')) {
        this.account = account;
        this.getOmtCampaignListByAccount(account.account_num)
          .pipe(
            tap((rs) => {
              this.accountCampaigns$.next(rs);
              this.campaign = rs[0];
              this.selectedCampaign$.next(rs[0]);
              return [account.accountNum, +rs[0].campaign_key];
            }),
          )
          .subscribe();
      }
    });
  }

  selectAccountByAccountNum(account_num): void {
    const account = _.find(this.activeAccounts$.getValue(), {
      account_num,
    });
    this.selectedAccount$.next(account);
  }

  selectAccount(account): void {
    this.selectedAccount$.next(account);
  }
  selectCampaign(campaign): void {
    this.selectedCampaign$.next(campaign);
  }
  //activeAccounts: any = [];
  getActiveAccounts(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.activeAccounts$.getValue()) && !reload_flag) {
      return of(this.activeAccounts$.getValue()).pipe();
    } else {
      //return this.efoEgi.getData('/omt/getActiveAccounts',{})
      return this.http.post(`${this.elevationUrl}/omt/getAllAccounts`, {}).pipe(
        map((rs) => {
          this.activeAccounts$.next(rs);
          return rs;
        }),
      );
    }
  }
  omtAccounts: any = [];
  getAllAccounts(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.omtAccounts) && !reload_flag) {
      return of(this.omtAccounts).pipe();
    } else {
      return this.http.post(`${this.elevationUrl}/omt/getAllAccounts`, {}).pipe(
        map((rs) => {
          this.omtAccounts = rs;
          return rs;
        }),
      );
    }
  }
  activeCampaign: any = [];
  getActiveCampaigns(reload_flag?): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.activeCampaign) && !reload_flag) {
      return of(this.activeCampaign).pipe();
    } else {
      return this.http
        .post(`${environment.nestElevationApiUrl}/omt/getActiveCampaigns`, {})
        .pipe(
          map((rs) => {
            this.activeCampaign = rs;
            return rs;
          }),
        );
    }
  }

  getActiveCampaignsByAccountNum(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/omt/getActiveCampaigns`,
      {
        account_num,
      },
    );
  }

  // getOmtCampaignListByAccount(account_num): Observable<any> {
  //   return this.efoEgi.getData('/omt/getOmtCampaignListByAccount', {
  //     account_num,
  //   });
  // }
  getOmtCampaignListByAccount(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/omt/getOmtCampaignListByAccount`,
      {
        account_num,
      },
    );
  }
  getRobomailBroadcastReport(vipcode): Observable<any> {
    return this.efoEgi.getData('/omt/getRobomailBroadcastReport', {
      vipcode: vipcode,
    });
  }
  saveLoadReports(): Observable<any> {
    return this.efoEgi.getData('/omt/saveLoadReports', {});
  }
  saveOmtSummaryReports(): Observable<any> {
    return this.efoEgi.getData('/omt/saveOmtSummaryReports', {});
  }
  saveOmtHistoryReports(): Observable<any> {
    return this.efoEgi.getData('/omt/saveOmtHistoryReports', {});
  }
  getCatReport(account_num, start_date, end_date): Observable<any> {
    return this.efoEgi.getData(
      '/omt/getCatReport',
      _.omitBy({ account_num, start_date, end_date }, _.isNull),
    );
  }
  getSalesCalendar(account_num): Observable<any> {
    return this.efoEgi.getData('/omt/getSalesCalendar', { account_num }).pipe(
      map((rs) => {
        _.each(rs, (d) => {
          d.mm = moment(d.m, 'M').format('MM');
        });
        return {
          salesCalendarData: rs,
          // @ts-ignore
          salesCalendarDataByYearMonth: this.efoLd.groupByMulti(rs, [
            'y',
            'mm',
          ]),
        };
      }),
    );
  }
  getAccountPerformanceChartSales(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/omt/getAccountPerformanceChartSales`,
      {
        account_num,
      },
    );
  }
  getAccountPerformanceChartService(account_num): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/omt/getAccountPerformanceChartService`,
      {
        account_num,
      },
    );
  }
  getOmtSummaryReport(
    account_num,
    campaign_key,
    start_date,
    end_date,
  ): Observable<any> {
    return this.efoEgi.getData('/omt/getOmtSummaryReport', {
      account_num,
      campaign_key,
      start_date,
      end_date,
    });
  }
  getOmtSalesReportByCampaign(
    account_num,
    campaign_key,
    start_date,
    end_date,
    full_report,
  ): Observable<any> {
    const params = {
      account_num,
      campaign_key,
      start_date,
      end_date,
      full_report,
    };
    const queryString = new URLSearchParams(params).toString();
    return this.http.get(
      `${environment.nestElevationApiUrl}/omt/getOmtSalesReportByCampaign?${queryString}`,
    );
  }
  getOmtServiceReportByCampaign(
    account_num,
    campaign_key,
    start_date,
    end_date,
    full_report,
  ): Observable<any> {
    const params = {
      account_num,
      campaign_key,
      start_date,
      end_date,
      full_report,
    };
    const queryString = new URLSearchParams(params).toString();
    return this.http.get(
      `${environment.nestElevationApiUrl}/omt/getOmtServiceReportByCampaign?${queryString}`,
    );
  }
  getOmtServiceSummary(campaign_key, start_date, end_date): Observable<any> {
    return this.efoEgi.getData('/omt/getOmtServiceSummary', {
      campaign_key,
      start_date,
      end_date,
    });
  }

  getRunningSalesTotals(account_num, options): Observable<any> {
    return this.efoEgi.getData(
      '/omt/getRunningSalesTotals',
      _.extend(
        {
          account_num,
          m: +moment().format('M'),
          d: +moment().format('D'),
          cols: 'dt,y,m,d,RunningTotalSales,RunningTotalMatches,RunningOurTotalConquests,RunningOurTotalConquestsPremium',
        },
        options,
      ),
    );
  }
  getTrackerTable(table_name, options): Observable<any> {
    return of([]);
    return this.efoEgi.getData(
      '/omt/getTrackerTable',
      _.extend({ table_name: table_name, limit: 10000 }, options),
    );
  }
  upsertEmailLink(link): Observable<any> {
    return this.efoEgi.postData('/omt/upsertEmailLink', link);
  }
  getStatusCheckingMatchDetails(
    account_num,
    campaign_key,
    statuses_key,
  ): Observable<any> {
    return this.efoEgi.getData('/omt/getStatusCheckingMatchDetails', {
      account_num,
      campaign_key,
      statuses_key: statuses_key,
    });
  }

  getStatusCheckingService(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/omt/getStatusCheckingService', {
      account_num,
      campaign_key,
    });
  }

  getStatusCheckingServiceMatchDetails(
    account_num,
    campaign_key,
    statuses_key,
  ): Observable<any> {
    return this.efoEgi.getData('/omt/getStatusCheckingServiceMatchDetails', {
      account_num,
      campaign_key,
      statuses_key: statuses_key,
    });
  }
  rejectStatuses(rejected_keys): Observable<any> {
    return this.efoEgi.getData('/omt/runUpdateStatusSp', {
      statuses_key: rejected_keys.join(','),
      status_update_type: 'reject',
    });
  }
  updateStatus(status_key, status_update_type): Observable<any> {
    return this.efoEgi.getData('/omt/runUpdateStatusSp', {
      statuses_key: status_key,
      status_update_type: status_update_type,
    });
  }
  getStatusChecking(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/omt/getStatusChecking', {
      account_num,
      campaign_key,
    });
  }
  getLockStatus(): Observable<any> {
    return this.efoEgi.getData('/omt/getLockStatus', {});
  }
  getRawFolder(): Observable<any> {
    return this.efoEgi.getData('/omt/getRawFolder', {});
  }
  getRawExcludeFolder(): Observable<any> {
    return this.efoEgi.getData('/omt/getRawExcludeFolder', {});
  }
  execLoad(): Observable<any> {
    return this.efoEgi.getData('/omt/execLoad', {});
  }
  moveToExcluded(filename): Observable<any> {
    return this.efoEgi.getData('/omt/moveToExcluded', { filename: filename });
  }
  getRobomailTargetResponseReport(vipcode): Observable<any> {
    return this.efoEgi.getData(
      '/eflow/robomail/getRobomailTargetResponseReport',
      { vipcode: vipcode },
    );
  }
  getRobomailCampaignLinks(vipcode): Observable<any> {
    return this.efoEgi.getData(
      '/eflow/robomail/elevate/getRobomailCampaignLinks',
      { vipcode: vipcode },
    );
  }
  getOmtHistoryReport(account_num): Observable<any> {
    return this.efoEgi.getData('/omt/getOmtHistoryReport', {
      account_num,
    });
  }
  getRobomailCampaignActivityReportAll(select_month): Observable<any> {
    return of([]);
    return this.efoEgi
      .getData('/omt/getRobomailCampaignActivityReportAll', {
        select_month: select_month,
      })
      .pipe(
        map((rs) => {
          _.each(rs, (d) => {
            d.clicked_cnt = _.sum(_.map(d.results, 'clicked'));
            d.viewed_cnt = _.sum(_.map(d.results, 'viewed'));
          });
          return rs;
        }),
      );
  }
  campaignExport(
    list_type,
    data_table_parameters,
    account_num,
    campaign_key,
    offset,
    limit,
  ): Observable<any> {
    return this.efoEgi.getData('/omt/campaignExport', {
      list_type: list_type,
      dataTableParameters: data_table_parameters,
      account_num,
      campaign_key,
      offset: offset,
      limit: limit,
    });
  }
  getCatFormRecord(vipcode): Observable<any> {
    return this.efoEgi.getData('/omt/getCatFormRecord', { vipcode: vipcode });
  }
  upsertCatForm(cat_form_data): Observable<any> {
    return this.efoEgi.postData('/omt/upsertCatForm', cat_form_data);
  }
  getJsonFile(filename): Observable<any> {
    return this.efoEgi.getData('/omt/getJsonFile', { filename: filename });
  }

  getOmtSummaryReportThisMonth(): Observable<any> {
    return this.getJsonFile('omtSummaryReport-ThisMonth');
  }
  getOmtSummaryReportLastMonth(): Observable<any> {
    return this.getJsonFile('omtSummaryReport-LastMonth');
  }
  getOmtHistoryReportThisMonth(): Observable<any> {
    return this.getJsonFile('omtHistoryReport-ThisMonth');
  }

  getRobomailDeliverabilityReport(): Observable<any> {
    return of([]);
    return this.efoEgi.getData('/omt/getRobomailDeliverabilityReport', {});
  }
  getCampaignFiles(vipcode): Observable<any> {
    return of([]);
    return this.efoEgi.getData('/omt/getCampaignFiles', { vipcode: vipcode });
  }
  getRobomailActivityReport(vipcode): Observable<any> {
    return of([]);
    return this.efoEgi.getData('/omt/getRobomailActivityReport', {
      vipcode: vipcode,
    });
  }
  // getRobomailCampaignLinks(vipcode): Observable<any> {
  //   return this.efoEgi.getData('/omt/getRobomailCampaignLinks', {vipcode:vipcode});
  // }
  marketingReport(account_num, campaign_key): Observable<any> {
    return this.efoEgi.getData('/omt/marketingReport', {
      account_num,
      campaign_key,
    });
  }

  getLoadReport(): Observable<any> {
    return this.efoEgi.getData('/omt/getLoadReport', {});
  }
  getFullSalesReport(account_num, start_date, end_date): Observable<any> {
    return this.efoEgi.getData('/omt/getFullSalesReport', {
      account_num,
      start_date,
      end_date,
    });
  }
  getFullServiceReport(account_num, start_date, end_date): Observable<any> {
    return this.efoEgi.getData('/omt/getFullServiceReport', {
      account_num,
      start_date,
      end_date,
    });
  }
  getDataGapsReport(gap): Observable<any> {
    return this.efoEgi.getData('/omt/getDataGapsReport', { gap: gap });
  }
  getMarketingTypesByCampaign(campaign_key): Observable<any> {
    return this.efoEgi.getData('/omt/getMarketingTypesByCampaign', {
      campaign_key,
    });
  }
  getCrossMarketingPreview(
    source_campaign_key,
    destination_campaign_key,
    source_type,
  ): Observable<any> {
    return this.efoEgi.getData('/omt/getCrossMarketingPreview', {
      source_campaign_key: source_type,
      destination_campaign_key: destination_campaign_key,
      source_type: source_type,
    });
  }

  runCrossMarketLoadSp(
    source_campaign_key,
    destination_campaign_key,
    source_type,
    marketing_date,
  ): Observable<any> {
    return this.efoEgi.getData('/omt/runCrossMarketLoadSp', {
      source_campaign_key: source_type,
      destination_campaign_key: destination_campaign_key,
      source_type: source_type,
      marketing_date: marketing_date,
    });
  }
  getCdkLookup(): Observable<any> {
    return this.efoEgi.getData('/omt/getCdkLookup', {});
  }
  upsertCdkLookup(cdk_data): Observable<any> {
    return this.efoEgi.postData('/omt/upsertCdkLookup', cdk_data);
  }

  matchingReport(): Observable<any> {
    return this.efoEgi.getData('/omt/matchingReport', {});
  }
  runMatchingSp(options): Observable<any> {
    return this.efoEgi.getData('/omt/runMatchingSp', options);
  }
  addEgiStatus(options): Observable<any> {
    return this.efoEgi.getData('/omt/addEgiStatus', options);
  }
  addEgiStatusRepairOrder(options): Observable<any> {
    return this.efoEgi.getData('/omt/addEgiStatusRepairOrder', options);
  }
  removeDuplicateSalesKeys(account_num): Observable<any> {
    return this.efoEgi.getData('/omt/removeDuplicateSalesKeys', {
      account_num,
    });
  }
  runUpdateStatusSp(options): Observable<any> {
    return this.efoEgi.getData('/omt/runUpdateStatusSp', options);
  }

  getNewMarketing(): Observable<any> {
    return this.efoEgi.getData('/omt/getNewMarketing', {});
  }

  getSalesConquestInfo(account_num): Observable<any> {
    return this.elevationService.getData('/omt/getSalesConquestInfo', {
      account_num,
    });
  }

  getServiceConquestInfo(account_num): Observable<any> {
    return this.elevationService.getData('/omt/getServiceConquestInfo', {
      account_num,
    });
  }
  calculateRoAvgHistory(account_num): Observable<any> {
    return this.elevationService.getData('/omt/calculateRoAvgHistory', {
      account_num,
    });
  }
  calculateMatchedRoAvgHistory(account_num): Observable<any> {
    return this.elevationService.getData('/omt/calculateMatchedRoAvgHistory', {
      account_num,
    });
  }

  public socketListen = () => {
    if (_.isUndefined(this.socket)) {
      this.socket = io(this.socketUrl, {
        transports: ['websocket'],
      });
      this.socket.on('connect', () => {
        this.socket.emit(
          'new-message',
          'portal service connected: omt.service',
        );
      });
    }
    return new Observable((observer) => {
      this.socket.on('omt', (data) => {
        observer.next(data);
      });
    });
  };
}
